import React, { Component } from "react";

import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import * as XLSX from "xlsx";

import FILE from "../../../assets/files/stock.xlsx";
export default class StockLists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,
      modal_stock_detail: false,
      modal_import: false,

      filter_search: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_warehouse_id: "",
      filter_company_id: "",
      filter_status: "",
      filter_activity_type: "",

      filter_stock_warehouse_id: null,
      filter_stock_category_id: "",
      filter_stock_search: "",

      data: [],
      data_stock: [],
      count: 10,
      data_product: [],
      data_warehouse: [],
      data_category: [],
      data_user: [],

      tab: "list-stock",

      // stock
      uid: "",
      document_no: "",
      type: "",
      name: "",
      date: format_date(new Date(), "yyyy-mm-dd", "en"),
      start_date: "",
      end_date: "",
      count_item: "",
      ref_number: "",
      activity_type: "ปรับจำนวน",
      customer_id: "",
      supplier_id: "",
      warehouse_id: "",
      destination_warehouse_id: "",
      user_id: "",
      amount: "",
      discount: "",
      vat: "",
      amount_net: "",
      cause: "",
      status: "",
      remark: "",
      transaction_list: [],

      // สินค้า
      photo: "",
      product_warehouse_id: "",
      product_code: "",
      product_name: "",
      category_id: "",
      unit_name: "",
      sale_price: "",
      cost_price: "",
      product_description: "",

      is_vat: false,
      delivery_cost: "",

      detail: null,

      show_serial_number: [],
      search_serial_number: "",

      import_data: [],
      visible: false
    };

        this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const { visible } = this.state;
    if (window.pageYOffset > 300 && !visible) {
      this.setState({ visible: true });
    } else if (window.pageYOffset <= 300 && visible) {
      this.setState({ visible: false });
    }
  };

scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_company_id,
      filter_status,
      filter_activity_type,
      filter_stock_search,
      filter_stock_warehouse_id,
      filter_stock_category_id,
    } = this.state;
    let _filter_stock_warehouse_id = filter_stock_warehouse_id;
    let data,
      count,
      data_warehouse,
      data_category,
      data_user,
      data_product,
      data_stock;
    loading(true);
    let [
      result,
      result_warehouse,
      result_category,
      result_user,
      result_product,
    ] = await Promise.all([
      GET("admin/stock-activities/list", {
        page: page,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        warehouse_id: filter_warehouse_id,
        supplier_id: filter_company_id,
        status_code: filter_status,
        type: filter_activity_type || "ปรับจำนวน,เพิ่มจำนวน,ลดจำนวน",
      }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
      GET("admin/setting/users/list", { page: 0, data_search: "" }),
      GET("admin/inventories/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
        prefix_name: e.prefix_name,
        name: e.name,
      }));

      if(filter_stock_warehouse_id === null){
      this.setState({filter_stock_warehouse_id: data_warehouse?.find(e=>(e.label).includes("เบนซิน"))?.value})
      _filter_stock_warehouse_id = data_warehouse?.find(e=>(e.label).includes("เบนซิน"))?.value
      }
    }
    if (result_category?.status) {
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse.uid,
      }));
    }

    if (result_user?.status) {
      data_user = result_user.data.map((e) => ({
        value: e.uid,
        label: e.full_name,
      }));
    }

    if (result_product?.status) {
      data_product = result_product.data?.filter((e) => e.products)
        .map((e) => ({
          value: e.products?.uid,
          label: `${e.products?.product_code} ${e.products?.product_name}`,
          id: e.products?.id,
          warehouse_id: e.products?.warehouse?.uid || "",
          unit_name: e.products?.unit_name,
          is_serial_number: e.products?.is_serial_number,
          product_code: e.products?.product_code,
          product_name: e.products?.product_name,
          category_id: e.products?.category?.uid || "",
          balance: e.balance,
        }));
      data_stock = result_product.data?.filter(
          (e) =>
            !filter_stock_search ||
            `${e.products?.product_code}${e.products?.product_name}`
              .toLowerCase()
              .includes(filter_stock_search.toLowerCase())
        )
        .filter(
          (e) =>
            !_filter_stock_warehouse_id ||
            e.products?.warehouse?.uid === _filter_stock_warehouse_id
        )
        .filter(
          (e) =>
            !filter_stock_category_id ||
            e.products?.category?.uid === filter_stock_category_id
        );
    }
    this.setState({
      data,
      count,
      data_warehouse,
      data_category,
      data_user,
      data_product,
      data_stock,
    });
    loading(false);
  };

  GetByID = async (uid) => {
    loading(true);
    let result = await GET("admin/stock-activities/list", { uid });
    this.setState({ detail: result.data, modal_detail: true });
    loading(false);
  };
  CreateUpdate = async (_status) => {
    const {
      data_product,
      id,
      uid,
      data,
      document_no,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,
      is_vat,
      delivery_cost,
    } = this.state;
    if (!date?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกวันที่ปรับปรุง");
      return;
    } else if (!activity_type?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทการปรับปรุง");
      return;
    } else if (!warehouse_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
      return;
    } else if (!user_id?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกผู้บันทึก");
      return;
    } else if (!cause?.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกสาเหตุการปรับปรุง");
      return;
    }
    loading(true);
    const vatRate = is_vat ? 0.07 : 0;

    let _amount = 0;

    let serial = false;
    transaction_list.forEach((item) => {
      const qty = Number(item.qty ?? 0);
      const unitPrice = Number(item.unit_price ?? 0);
      const itemDiscount = Number(item.discount ?? 0);
      _amount += qty * (unitPrice - itemDiscount);
      item.serial_number = item.serial_number
        .toString()
        .split(",")
        .filter((e) => e);
      if (
        item.serial_number.length !== qty &&
        data_product.find((e) => e.value === item.product_id)?.is_serial_number
      ) {
        serial = true;
      }
      if (!item.product_code) {
        alert("", "warning", "แจ้งเตือน", "กรุณาเลือกสินค้าให้ครบถ้วน");
        loading(false);
        return;
      }
    });

    if (serial) {
      loading(false);
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        "จำนวน Serial Number กับ จำนวนสินค้าบางรายการไม่ตรงกัน"
      );
      return;
    }
    let body = {
      type: activity_type,
      name,
      date,
      start_date,
      end_date,
      count_item: transaction_list.length,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount: Number(_amount),
      discount: 0,
      vat: 0,
      delivery_cost: 0,
      amount_net: Number(_amount),
      cause,
      status: _status || "รอดำเนินการ",
      remark,
      transaction_list,
    };

    let result = !uid
      ? await POST("admin/stock-activities/create", body)
      : await PUT("admin/stock-activities/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
      );
    }
    loading(false);
  };

  handleFileUpload = (e) => {
    const { data_warehouse } = this.state;
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;

      // อ่านไฟล์ Excel
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      // อ่านแค่ sheet แรก
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // แปลง sheet เป็น JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      this.setState({
        import_data: jsonData.map((e) => {
          return {
            warehouse_id:
              data_warehouse.find(
                (w) =>
                  w.prefix_name === e["คลังสินค้า"] ||
                  w.name === e["คลังสินค้า"]
              )?.value || "",
            product_code: e["รหัสสินค้า"],
            serial_number: e["Serial Number"],
            qty: e["จำนวนคงเหลือ"],
          };
        }),
        modal_import: true,
      });
      document.getElementById("file").value = "";
      document.getElementById("file").files = null;
    };

    reader.readAsBinaryString(file);
  };

  chunkBy = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  Import = async () => {
    const { import_data } = this.state;
    try {
      loading(true);
      // 🌀 วนทีละ batch
      const result = await POST("admin/stock-activities/import", {
        transaction_list: import_data,
      });
      loading(false);
      // ✅ ประเมินผลรวม
      if (result.status) {
        alert("#", "success");
      }
    } catch (error) {
      loading(false);
      console.error("Import error:", error);
      alert("", "warning", "แจ้งเตือน", "เกิดข้อผิดพลาดระหว่างนำเข้า");
    }
  };

  render() {
    const {
      modal_detail,
      modal_stock_detail,
      modal_import,
      tab,

      filter_search,
      filter_product_id,
      filter_warehouse_id,
      filter_category_id,
      filter_company_id,
      filter_start_date,
      filter_end_date,
      filter_activity_type,
      filter_status,
      filter_stock_search,
      filter_stock_warehouse_id,
      filter_stock_category_id,

      data,
      count,
      data_user,
      data_receive,
      data_warehouse,
      data_company,
      data_product,
      data_category,
      data_stock,

      // stock
      uid,
      document_no,
      type,
      name,
      date,
      start_date,
      end_date,
      count_item,
      ref_number,
      activity_type,
      customer_id,
      supplier_id,
      warehouse_id,
      destination_warehouse_id,
      user_id,
      amount,
      discount,
      vat,
      amount_net,
      cause,
      status,
      remark,
      transaction_list,

      // สินค้า
      photo,
      product_warehouse_id,
      product_code,
      product_name,
      category_id,
      unit_name,
      sale_price,
      cost_price,
      product_description,

      is_vat,
      delivery_cost,

      detail,
      show_serial_number,
      search_serial_number,

      import_data,
      visible
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <input
          hidden
          id="file"
          type="file"
          accept=".xlsx, .xls"
          onChange={(event) => this.handleFileUpload(event)}
        />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between flex-wrap mb-3">
              <h4 className="fw-bold mb-3 me-3">จัดการสต็อกสินค้า</h4>
              <div className="border-1 border-secondary rounded-4 p-1 d-flex bg-light">
                <button
                  className={`btn ${
                    tab === "list-stock" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({ tab: "list-stock" });
                  }}
                >
                  รายการสต็อก
                </button>
                <div style={{ width: 4 }}></div>
                <button
                  className={`btn ${
                    tab === "adjust" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({ tab: "adjust" });
                  }}
                >
                  ปรับปรุงสต็อก
                </button>
                <div style={{ width: 4 }}></div>
                <button
                  className={`btn ${
                    tab === "adjust-list" ? "btn-dark" : "btn-light"
                  } px-3`}
                  onClick={async () => {
                    this.setState({ tab: "adjust-list" });
                  }}
                >
                  รายการปรับปรุงสต็อก
                </button>
              </div>
            </div>
            {tab === "list-stock" && (
              <div>
                <div className="d-flex align-items-center flex-wrap mb-3">
                  <input
                    type="text"
                    className="form-control wpx-200 me-2 mb-2"
                    placeholder="ค้นหา รหัสสินค้า,ชื่อสินค้า..."
                    onChange={(e) => {
                      this.setState({ filter_stock_search: e.target.value });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        this.Get();
                      }
                    }}
                    value={filter_stock_search}
                  />

                  <div className="wpx-200 me-2 mb-2">
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้า..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ filter_stock_warehouse_id: e });
                      }}
                      value={filter_stock_warehouse_id}
                    />
                  </div>
                  <div className="wpx-200 me-2 mb-2">
                    <Select
                      className="form-control"
                      placeholder="หมวดหมู่..."
                      options={data_category?.filter(
                        (e) => e.warehouse_id === filter_stock_warehouse_id
                      )}
                      onChange={(e) => {
                        this.setState({ filter_stock_category_id: e });
                      }}
                      value={filter_stock_category_id}
                    />
                  </div>
                  <div className="d-flex">
                    <button
                      className="btn btn-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.Get();
                      }}
                    >
                      ค้นหา
                    </button>
                    <button
                      className="btn btn-outline-dark px-3 me-2 mb-2"
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      ล้างค่า
                    </button>
                  </div>
                  <div className="stock-lists.create">
                    <button
                      className="btn btn-info px-3 ms-2 mb-0"
                      onClick={async () => {
                        document.getElementById("file").click();
                      }}
                    >
                      import excel
                    </button>
                    <div className="hpx-10 px-2">
                      <a
                        className="text-10 px-2 text-primary"
                        style={{ marginTop: -4 }}
                        href={FILE}
                        download="template.xlsx"
                      >
                        template.xlsx
                      </a>
                    </div>
                  </div>
                   <div className="ms-2 mb-1">
                                  <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                                    filename="สต็อกสินค้า"
                                    sheet="สต็อกสินค้า"
                                    currentTableRef={this.tableRef.current}
                                  >
                                    <button className="btn btn-warning px-3 mb-2">Export Excel</button>
                                  </DownloadTableExcel>
                                </div>
                </div>
                <div className="table-responsive" style={{maxHeight:"60vh"}}>
                  <table className="table rounded-3 overflow-hidden table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">รหัสสินค้า</td>
                        <td className="text-nowrap">ชื่อสินค้า</td>
                        <td className="text-nowrap">หมวดหมู่</td>
                        <td className="text-nowrap">คลังสินค้า</td>
                        <td className="text-nowrap text-end">จำนวนคงเหลือ</td>
                        <td className="text-nowrap">หน่วย</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {data_stock
                        ?.filter((e) => e.products)

                        .sort((a, b) =>
                          a.products.product_code.localeCompare(
                            b.products.product_code
                          )
                        )
                        .map((item, index) => (
                          <tr>
                            <td className="text-nowrap">
                              {item.products?.product_code || "-"}
                            </td>
                            <td className="text-nowrap">
                              {item.products?.product_name || "-"}
                            </td>
                            <td className="text-nowrap">
                              {item.products?.category?.name || "-"}
                            </td>
                            <td className="text-nowrap">
                              {item.products?.warehouse?.name || "-"}
                            </td>
                            <td className="text-nowrap text-end">
                              {item.balance || "0"}
                            </td>
                            <td className="text-nowrap">
                              {item.products?.unit_name || "-"}
                            </td>
                            <td className="text-center align-middle wpx-100">
                              <div className="d-flex">
                                <BtnIcon
                                  type="view"
                                  onClick={() => {
                                    this.setState({
                                      modal_stock_detail: true,
                                      show_serial_number: ["string","number"].includes(typeof(item.serial_number)) ? item.serial_number.toString()?.split(",").map(e=>e.trim()) :item.serial_number,
                                      search_serial_number: "",
                                    });
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <div style={{height:0,opacity:0,overflow:"hidden"}}>
                  <table className="table rounded-3 overflow-hidden table-hover" ref={this.tableRef}>
                    <thead>
                      <tr>
                        <td className="text-nowrap">รหัสสินค้า</td>
                        <td className="text-nowrap text-end">Serial Number</td>
                        <td className="text-nowrap text-end">จำนวนคงเหลือ</td>
                        <td className="text-nowrap">คลังสินค้า</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {data_stock
                        ?.filter((e) => e.products).sort((a, b) => a.products.product_code.localeCompare(b.products.product_code))
                        .map((item, index) => (
                          <tr>
                            <td className="text-nowrap">
                              {item.products?.product_code || "-"}
                            </td>
                            <td className="text-nowrap text-end">
                              {item.serial_number?.toString() || ""}
                            </td>
                            <td className="text-nowrap text-end">
                              {item.balance || "0"}
                            </td>
                            <td className="text-nowrap">
                              {item.products?.warehouse?.name || "-"}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            {tab === "adjust" && (
              <div>
                <div className="row mb-3">
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">รหัสเอกสารปรับปรุง{required}</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="รหัสเอกสารปรับปรุง..."
                      onChange={(e) => {
                        this.setState({ document_no: e.target.value });
                      }}
                      value={document_no}
                      disabled
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">คลังสินค้า{required}</div>
                    <Select
                      className="form-control"
                      placeholder="คลังสินค้า..."
                      options={data_warehouse}
                      onChange={(e) => {
                        this.setState({ warehouse_id: e });
                      }}
                      value={warehouse_id}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">วันที่ปรับปรุง{required}</div>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="วันที่ปรับปรุง..."
                      onChange={(e) => {
                        this.setState({ date: e.target.value });
                      }}
                      value={date}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">ผู้บันทึก{required}</div>
                    <Select
                      className="form-control"
                      placeholder="ผู้บันทึก..."
                      options={data_user}
                      onChange={(e) => {
                        this.setState({ user_id: e });
                      }}
                      value={user_id}
                    />
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">ประเภทการปรับปรุง{required}</div>
                    <div className="w-100 d-flex">
                      <div className="w-100 border-1 border-secondary rounded-4 p-1 d-flex bg-light">
                        <button
                          className={`w-100 hpx-25 py-0 btn ${
                            activity_type === "ปรับจำนวน"
                              ? "btn-dark"
                              : "btn-light"
                          } px-3`}
                          onClick={async () => {
                            this.setState({ activity_type: "ปรับจำนวน" });
                          }}
                        >
                          ปรับ
                        </button>
                        <div style={{ width: 4 }}></div>
                        <button
                          className={`w-100 hpx-25 py-0 btn ${
                            activity_type === "เพิ่มจำนวน"
                              ? "btn-dark"
                              : "btn-light"
                          } px-3`}
                          onClick={async () => {
                            this.setState({ activity_type: "เพิ่มจำนวน" });
                          }}
                        >
                          เพิ่ม
                        </button>
                        <div style={{ width: 4 }}></div>
                        <button
                          className={`w-100 hpx-25 py-0 btn ${
                            activity_type === "ลดจำนวน"
                              ? "btn-dark"
                              : "btn-light"
                          } px-3`}
                          onClick={async () => {
                            this.setState({ activity_type: "ลดจำนวน" });
                          }}
                        >
                          ลด
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-md-6 col-xl-4 mb-2">
                    <div className="mb-1">สาเหตุการปรับปรุง{required}</div>
                    <select
                      className="form-control"
                      onChange={(e) => {
                        this.setState({ cause: e.target.value });
                      }}
                      value={cause}
                    >
                      <option value="">สาเหตุการปรับปรุง</option>
                      <option value="ตรวจนับสต็อก">ตรวจนับสต็อก</option>
                      <option value="สินค้าเสียหาย/ชำรุด/ปรับสต็อก">
                        สินค้าเสียหาย/ชำรุด/ปรับสต็อก
                      </option>
                    </select>
                  </div>
                </div>
                <hr />
                <hr />
                <div>
                  <div className="d-flex flex-wrap">
                    <Select
                      type="text"
                      className="form-control wpx-200 me-2 mb-2"
                      placeholder="ค้นหาสินค้า..."
                      options={data_product}
                      onChange={(e) => {
                        this.setState({ filter_product_id: e.target.value });
                      }}
                      value={filter_product_id}
                    />
                    <div className="d-flex">
                      <button
                        className="btn btn-dark px-3 me-2 mb-2"
                        onClick={() => {
                          this.setState(
                            {
                              transaction_list: [
                                ...this.state.transaction_list,
                                {
                                  uid: "",
                                  type: "",
                                  product_id: "",
                                  product_name: "",
                                  product_code: "",
                                  product_type: "",
                                  serial_number: "",
                                  warehouse_id: "",
                                  warehouse_name: "",
                                  category_id: "",
                                  category_name: "",
                                  qty: 1,
                                  unit_name: "",
                                  cause: "",
                                  discount: "",
                                  sale_price: "",
                                  cost_price: "",
                                  unit_price: "",
                                  amount: "",
                                },
                              ],
                            },
                            () => {
                              try {
                                const index =
                                  this.state.transaction_list.length - 1;
                                document
                                  .getElementById("price-" + index)
                                  ?.focus();
                              } catch (e) {
                                console.error(
                                  "Error focusing on product input:",
                                  e
                                );
                              }
                            }
                          );
                        }}
                      >
                        เพิ่มรายการ
                      </button>
                    </div>
                  </div>
                  <div>
                    <table className="table rounded-3 table-hover">
                      <thead>
                        <tr>
                          <td className="text-nowrap">ลำดับ</td>
                          <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                          <td className="text-nowrap">Serial No</td>
                          <td className="text-nowrap text-center">จำนวนเดิม</td>
                          <td className="text-nowrap text-center">
                            จำนวนที่ปรับปรุง
                          </td>
                          <td className="text-nowrap">จำนวนใหม่</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {transaction_list?.map((item, index) => (
                          <tr>
                            <td className="text-nowrap">{index + 1}</td>
                            <td className="text-nowrap">
                              <Select
                                className="form-control"
                                placeholder="ค้นหาสินค้า..."
                                options={data_product?.filter(
                                  (e) =>
                                    warehouse_id &&
                                    e.warehouse_id === warehouse_id
                                )}
                                onChange={(e, i) => {
                                  transaction_list[index].product_id = e;
                                  transaction_list[index].product_code =
                                    i.product_code;
                                  transaction_list[index].product_name =
                                    i.product_name;
                                  transaction_list[index].unit_name =
                                    i.unit_name;
                                  transaction_list[index].category_id =
                                    i.category_id;
                                  this.setState({ transaction_list });
                                }}
                                value={item.product_id}
                              />
                            </td>

                            <td className="text-nowrap">
                              {data_product.find(
                                (e) => e.value === item.product_id
                              )?.is_serial_number && (
                                <input
                                  type="text"
                                  className="form-control mx-1"
                                  onChange={(e) => {
                                    transaction_list[index].serial_number =
                                      e.target.value;
                                    this.setState({ transaction_list });
                                  }}
                                  value={item.serial_number}
                                />
                              )}
                            </td>
                            <td className="text-nowrap text-center">
                              {data_product?.find(
                                (e) => e.value === item.product_id
                              )?.balance || 0}
                            </td>
                            <td className="text-nowrap">
                              <div className="d-flex align-items-center">
                                <button
                                  className="btn btn-primary wpx-30"
                                  onClick={async () => {
                                    if (item.qty <= 1) {
                                      if (
                                        await alert(
                                          "",
                                          "info",
                                          "ยืนยัน",
                                          "ยืนยันการลบข้อมูลนี้หรือไม่",
                                          "ลบข้อมูล",
                                          "ยกเลิก"
                                        )
                                      ) {
                                        this.setState({
                                          transaction_list:
                                            transaction_list?.filter(
                                              (_, i) => i !== index
                                            ),
                                        });
                                      }
                                    } else {
                                      transaction_list[index].qty = Math.max(
                                        0,
                                        item.qty - 1
                                      );
                                      this.setState({ transaction_list });
                                    }
                                  }}
                                >
                                  -
                                </button>
                                <input
                                  type="text"
                                  className="form-control wpx-60 mx-1 text-center"
                                  onChange={(e) => {
                                    if (!float(e.target.value)) return;
                                    transaction_list[index].qty = Number(
                                      e.target.value
                                    );
                                    this.setState({ transaction_list });
                                  }}
                                  value={item.qty}
                                />
                                <button
                                  className="btn btn-primary wpx-30"
                                  onClick={() => {
                                    transaction_list[index].qty = Math.max(
                                      0,
                                      item.qty + 1
                                    );
                                    this.setState({ transaction_list });
                                  }}
                                >
                                  +
                                </button>
                              </div>
                            </td>
                            <td className="text-nowrap text-center">
                              {activity_type === "ปรับจำนวน"
                                ? item.qty
                                : activity_type === "เพิ่มจำนวน"
                                ? (data_product?.find(
                                    (e) => e.value === item.product_id
                                  )?.balance || 0) + Number(item.qty)
                                : (data_product?.find(
                                    (e) => e.value === item.product_id
                                  )?.balance || 0) - Number(item.qty)}
                            </td>
                            <td className="text-center align-middle wpx-100">
                              <div className="d-flex">
                                <BtnIcon
                                  className="receive-goods.delete"
                                  type="delete"
                                  onClick={async () => {
                                    if (
                                      await alert(
                                        "",
                                        "info",
                                        "ยืนยัน",
                                        "ยืนยันการลบข้อมูลนี้หรือไม่",
                                        "ลบข้อมูล",
                                        "ยกเลิก"
                                      )
                                    ) {
                                      this.setState({
                                        transaction_list:
                                          transaction_list?.filter(
                                            (_, i) => i !== index
                                          ),
                                      });
                                    }
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="w-100 mb-3">
                  <div className="mb-1">หมายเหตุ</div>
                  <textarea
                    rows={8}
                    type="text"
                    className="form-control"
                    placeholder="หมายเหตุ..."
                    onChange={(e) => {
                      this.setState({ remark: e.target.value });
                    }}
                    value={remark}
                  />
                </div>

                <div className="pt-0 border-0 d-flex justify-content-between">
                  {uid ? (
                    <div className="d-flex">
                      <button
                        className="btn btn-dark px-5 me-1"
                        onClick={async () => {
                          if (
                            await alert(
                              "",
                              "warning",
                              "คืนสินค้า",
                              "ยืนยันรายการนี้หรือไม่ ?",
                              "ยืนยัน",
                              "ยกเลิก"
                            )
                          ) {
                            this.CreateUpdate("คืนสินค้าแล้ว");
                          }
                        }}
                      >
                        เสร็จสิ้น
                      </button>
                      {activity_type === "เคลมสินค้า" &&
                        status === "ส่งเคลมออก" && (
                          <button
                            className="btn btn-primary px-5 me-1"
                            onClick={async () => {
                              if (
                                await alert(
                                  "",
                                  "warning",
                                  "รับเคลมเข้า",
                                  "ยืนยันรายการนี้หรือไม่ ?",
                                  "ยืนยัน",
                                  "ยกเลิก"
                                )
                              ) {
                                this.CreateUpdate("รับเคลมเข้า");
                              }
                            }}
                          >
                            รับเคลมเข้า
                          </button>
                        )}
                      <button
                        className="btn btn-danger px-5 me-1"
                        onClick={async () => {
                          if (
                            await alert(
                              "",
                              "warning",
                              "ยกเลิก",
                              "ยืนยันการยกเลิกรายการนี้หรือไม่ ?",
                              "ยืนยัน",
                              "ยกเลิก"
                            )
                          ) {
                            this.CreateUpdate("ยกเลิก");
                          }
                        }}
                      >
                        ยกเลิก
                      </button>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <div className="d-flex">
                    <button
                      className="btn btn-dark px-5 me-1"
                      onClick={() => {
                        this.CreateUpdate("รอดำเนินการ");
                      }}
                    >
                      บันทึกการปรับสต็อก
                    </button>
                  </div>
                </div>
              </div>
            )}
            {tab === "adjust-list" && (
              <div>
                <div className="d-flex align-items-center flex-wrap">
                  <input
                    type="text"
                    className="form-control wpx-200 me-2 mb-2"
                    placeholder="ค้นหา เลขที่เอกสาร..."
                    onChange={(e) => {
                      this.setState({ filter_search: e.target.value });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        this.Get(1);
                      }
                    }}
                    value={filter_search}
                  />
                  <input
                    type="date"
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_start_date: e.target.value });
                    }}
                    value={filter_start_date}
                  />
                  <span className="px-2 me-2 mb-2">ถึง</span>
                  <input
                    type="date"
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_end_date: e.target.value });
                    }}
                    value={filter_end_date}
                  />
                  <select
                    className="form-control wpx-200 me-2 mb-2"
                    onChange={(e) => {
                      this.setState({ filter_activity_type: e.target.value });
                    }}
                    value={filter_activity_type}
                  >
                    <option value="">ประเภทการปรับปรุง</option>
                    <option value="ปรับจำนวน">ปรับจำนวน</option>
                    <option value="เพิ่มจำนวน">เพิ่มจำนวน</option>
                    <option value="ลดจำนวน">ลดจำนวน</option>
                  </select>

                  <div className="d-flex">
                    <button
                      className="btn btn-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.Get(1);
                      }}
                    >
                      ค้นหา
                    </button>
                    <button
                      className="btn btn-outline-dark px-3 me-2 mb-2"
                      onClick={() => {
                        this.setState({
                          filter_search: "",
                          filter_receive_date: "",
                          filter_warehouse_id: "",
                          filter_company_id: "",
                          filter_category_id: "",
                          filter_status: "",
                          filter_start_date: "",
                          filter_end_date: "",
                          filter_activity_type: "",
                        });
                        setTimeout(() => {
                          this.Get(1);
                        }, 100);
                      }}
                    >
                      ล้างค่า
                    </button>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="table rounded-3 overflow-hidden table-hover">
                    <thead>
                      <tr>
                        <td className="text-nowrap">รหัสเอกสารปรับปรุง</td>
                        <td className="text-nowrap">วันที่ปรับปรุง</td>
                        <td className="text-nowrap">ผู้บันทึก</td>
                        <td className="text-nowrap">ประเภทการปรับปรุง</td>
                        <td className="text-nowrap">สาเหตุที่ปรับปรุง</td>
                        <td className="text-nowrap">คลังสินค้า</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, index) => (
                        <tr>
                          <td className="text-nowrap">
                            {item.document_no || "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.date ? format_date(item.date) : "-"}
                          </td>
                          <td className="text-nowrap">
                            {item.user?.full_name || "-"}
                          </td>
                          <td className="text-nowrap">{item.type || "-"}</td>
                          <td className="text-nowrap">{item.cause || "-"}</td>
                          <td className="text-nowrap">
                            {item.warehouse?.name || "-"}
                          </td>
                          <td className="text-center align-middle wpx-100">
                            <div className="d-flex">
                              <BtnIcon
                                type="view"
                                onClick={() => {
                                  this.GetByID(item.uid);
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
                  <Pagination
                    className="mb-3"
                    count={Math.ceil(count / 10) || 1}
                    showFirstButton
                    showLastButton
                    onChange={(_, page) => this.Get(page)}
                  />
                </div>
              </div>
            )}
          </div>

          {visible && (
            <button
              className="position-fixed btn btn-primary"
              onClick={() => {
                this.scrollToTop();
              }}
              style={{ top: 30, right: 30 }}
            >
              กดเพื่อไปยังด้านบน
            </button>
          )}
        </div>

        {/* VIEW */}
        <Modal
          show={this.state.modal_detail}
          onHide={() => this.setState({ modal_detail: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <h4 className="mb-0">รายละเอียด</h4>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">สถานะ</label>
              <label>
                {Status("เสร็จสิ้น", "success")}
              </label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">รหัสเอกสารปรับปรุง</label>
              <label>{detail?.document_no || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">คลังสินค้า</label>
              <label>{detail?.warehouse?.name || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">วันที่ปรับปรุง</label>
              <label>{detail?.date ? format_date(detail?.date) : ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">ผู้บันทึก</label>
              <label>{detail?.user?.full_name || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">ประเภทการปรับปรุง</label>
              <label>{detail?.activity_type || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">สาเหตุการปรับปรุง</label>
              <label>{detail?.cause || ""}</label>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap text-center">
                      จำนวนที่ปรับปรุง
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {detail?.transaction_list?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">
                        {item.product_code} {item.product_name}
                      </td>
                      <td className="text-nowrap">{item.qty}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">หมายเหตุ</label>
              <label>{detail?.remark || ""}</label>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.modal_stock_detail}
          onHide={() => this.setState({ modal_stock_detail: false })}
        >
          <Modal.Header closeButton>
            <h4 className="mb-0">Serail Number</h4>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <input
              type="text"
              className="form-control mb-3"
              placeholder="ค้นหาเลข Serial Number..."
              onChange={(e) => {
                this.setState({ search_serial_number: e.target.value });
              }}
              value={search_serial_number}
            />
            <ul>
              {typeof(show_serial_number) === "string" ? (<li>{show_serial_number}</li>) : 
              show_serial_number?.filter((e) => e.includes(search_serial_number))?.map((item) => (
                  <li>{item}</li>
                ))}
            </ul>
          </Modal.Body>
        </Modal>

        <Modal
          show={modal_import}
          onHide={() => this.setState({ modal_import: false })}
          size="lg"
        >
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">รายการนำเข้า</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">รหัสสินค้า</td>
                    <td className="text-nowrap">Serial Number</td>
                    <td className="text-nowrap text-end">จำนวนคงเหลือ</td>
                  </tr>
                </thead>
                <tbody>
                  {import_data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {data_warehouse?.find(
                          (e) => e.value === item.warehouse_id
                        )?.label || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.product_code || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.serial_number || "-"}
                      </td>
                      <td className="text-nowrap text-end">
                        {item.qty || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.Import();
                }}
              >
                นำเข้า
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_import: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
